import { AbstractCommand } from 'src/models/command';
import { Task, TaskAlarmConfig } from 'src/models/task';

type TaskSaveType = 'withRepetition' | 'withoutRepetition';

const notifiableUserIdFromAggregateId = (aggregateId: string): null | string => {
	try {
		const parsedAggregateId = JSON.parse(aggregateId) as { userId?: number | string };
		const userId = parsedAggregateId.userId;

		if (typeof userId === 'number' || (typeof userId === 'string' && userId !== '')) {
			return String(userId);
		}
	} catch {
		return null;
	}

	return null;
};

const buildNotifiableUsersMap = (alarmConfig: TaskAlarmConfig | undefined): Record<string, string> => {
	const notifiableUsers: Record<string, string> = {};

	(alarmConfig?.alarmConfigNotifiableUsers ?? []).forEach((notifiableUser) => {
		const userId = notifiableUserIdFromAggregateId(notifiableUser.aggregateId);

		if (userId !== null) {
			notifiableUsers[userId] = 'on';
		}
	});

	return notifiableUsers;
};

class ProcessTaskCommand extends AbstractCommand {
	public apiVersion = 2;
	readonly name = 'IFS_DesktopModule_Task_Command_Command_ProcessTaskCommand';

	public constructor(task: Task, saveType: TaskSaveType) {
		super();
		this.parameters = {
			activitylinkButton: task.activitylinkButton,
			aggregateId: task.aggregateId,
			aggregateVersion: task.aggregateVersion,
			alarmConfig: { ...task.alarmConfig, notifiableUsers: buildNotifiableUsersMap(task.alarmConfig) },
			content: task.content,
			fixedMaturityDate: task.fixedMaturityDate,
			forerunTime: task.forerunTime,
			processId: task.processId,
			repetitionConfig: task.repetitionConfig,
			responsibleUserId: task.responsibleUserId,
			saveType: saveType,
			title: task.title,
		};
	}
}

export { ProcessTaskCommand };
export type { TaskSaveType };
